














import Vue from "vue";
import iwInputGroupStepper from "@/encoding/components/buildingBlocks/InputGroupStepper.vue";

export default Vue.extend({
    components: {
        iwInputGroupStepper: iwInputGroupStepper
    },
    data: function() {
        return {
            pathInStore: "property.livingDescription.roomCount",
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE", "APARTMENT", "OTHER","HOMES_TO_BUILD"].indexOf(this.getPropertyType()) !== - 1;
        },
        numberOfRooms: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        isCountryFrance: function(): boolean {
            return this.$store.getters["FormModule/getValue"]("property.location.address.country") === "FR";
        }
    },
    mounted: function() {
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStore);
        }
    },
    methods: {
        updateValue: function(numberOfRooms: number): void {
            if (numberOfRooms === 0) {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": numberOfRooms});
            }
        }
    },
});

